export type AssistantView = 'chat' | 'lead'

export function resolveAssistantView({
  hasSession,
  issuer,
}: {
  hasSession: boolean
  issuer?: string
}): AssistantView {
  return hasSession && issuer === 'opendock' ? 'chat' : 'lead'
}
